import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import type { ThemeMode } from '../../../src/theme/ThemeContext';

export const getSportStandingsTableStyles = (theme: Theme, themeMode: ThemeMode = 'light') => {
  const isDark = themeMode === 'dark';

  return StyleSheet.create({
    card: {
      borderRadius: 14,
      overflow: 'hidden',
      backgroundColor: isDark ? theme.gray[100] : theme.white,
      borderWidth: 1,
      borderColor: isDark ? theme.gray[300] : theme.gray[200],
    },
    headerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 10,
      paddingHorizontal: 12,
      backgroundColor: isDark ? theme.gray[200] : theme.gray[100],
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 10,
      paddingHorizontal: 12,
      borderBottomWidth: 1,
      borderBottomColor: isDark ? theme.gray[300] : theme.gray[200],
    },
    rowLast: {
      borderBottomWidth: 0,
    },
    positionCell: {
      width: 24,
      textAlign: 'left',
    },
    teamCell: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      minWidth: 0,
    },
    teamName: {
      flexShrink: 1,
      fontSize: 13,
      fontWeight: '600',
      color: theme.gray[900],
    },
    headerCell: {
      width: 38,
      textAlign: 'center',
      fontSize: 11,
      fontWeight: '700',
      color: theme.gray[600],
      letterSpacing: 0.3,
    },
    cell: {
      width: 38,
      textAlign: 'center',
      fontSize: 13,
      fontWeight: '600',
      color: theme.gray[800],
    },
    emptyWrap: {
      paddingVertical: 28,
      alignItems: 'center',
    },
    emptyText: {
      fontSize: 13,
      color: theme.gray[600],
    },
  });
};
